export const drmMethods = {
	open: 'open',
	adobe: 'adobe',
};
